import { gql, useMutation } from "@apollo/client";
import { useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch } from "react-redux";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";

const Close_Track = gql`
  mutation Close_TripTrack($tripId: String) {
    Close_TripTrack(tripId: $tripId) {
      message
    }
  }
`;

const CloseShipMentTrack = ({ show, tripId, setShowModal, fetchAllLoad }) => {
  const [toggle, settoggle] = useState(show);
  const dispatch = useDispatch();
  const [Close, { loading: AddLoadLoadingState }] = useMutation(Close_Track, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  let submit = async () => {
    await Close({
      variables: {
        tripId: tripId,
      },
    })
      .then(({ data }) => {
        const message = data.Close_TripTrack.message.includes("No trip available of this trip Id");
        if (message) {
          ErrorToast(data.Close_TripTrack.message);
        } else {
          SuccessToast("Shipment Closed Successfully");
          setShowModal(false);
          dispatch({ type: "Refetch", payload: true });
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };
  
  return (
    <Reactportal open={toggle} onClose={() => setShowModal(false)} TypeOfPortal={"Confirm"}>
      <div className="warning">
        <RiErrorWarningFill className="warningIcon" />
        <p className="warningMsg">Are You Sure You Want to Close this Shipment?</p>
      </div>

      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={"Close ShipMent"}
        handleformclose={() => {
          setShowModal(false);
        }}
        loadingState={AddLoadLoadingState}
      />
    </Reactportal>
  );
};

export default CloseShipMentTrack;
